import { render, staticRenderFns } from "./EduClassCourse.vue?vue&type=template&id=4dee1d23&scoped=true"
import script from "./EduClassCourse.vue?vue&type=script&lang=js"
export * from "./EduClassCourse.vue?vue&type=script&lang=js"
import style0 from "./EduClassCourse.vue?vue&type=style&index=0&id=4dee1d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee1d23",
  null
  
)

export default component.exports